// extracted by mini-css-extract-plugin
export default {"title":"AirportHotelDetails_title__I5UV5","total":"AirportHotelDetails_total__brNJn","edit":"AirportHotelDetails_edit__+vzgn"};